(ns guidebook.views.notes
  (:require
   [reagent.core :as r]
   [very.re-frame.core :as rf :refer [<sub >evt]]
   [css.core
    :refer [get-theme]
    :refer-macros [defstyled]]
   [css.form :as form]
   [css.icons :as  icon])
  (:require-macros
   [logging.core :refer [log]]))

(defstyled notes-s :div
  {:position "absolute"
   :background-color "white"
   :width "550px"
   :top "60px"
   :right "0"
   :padding "30px"
   :box-shadow "1px 1px 4px rgba(0,0,0,0.3)"})

(defstyled notes-header-s :div
  {:display "flex"
   :justify-content "space-between"
   :align-items "center"})

(defstyled notes-title-s :h4
  {:color "#525151"
   :font-size "20px"
   :font-weight "700"})

(defstyled notes-close-s :div
  {:cursor "pointer"})

(defstyled notes-text-area-s :textarea
  {:border "1px solid #fafafa"
   :font-size "22px"
   :resize "none"
   :width "100%"
   :max-width "100%"
   :height "180px"
   :margin "30px 0"
   :padding "15px"
   :font-weight "300"})

(defstyled notes-submit-s :input
  {:background "black"
   :color "white"
   :width "100%"
   :font-size "20px"
   :height "60px"
   :display "flex"
   :align-items "center"
   :justify-content "center"
   :border "none"
   :cursor "pointer"
   :&:disabled {:cursor "not-allowed"
                :color "lightgrey"}})

(defn main []
  (let [form-values (r/atom {})]
    (fn [{:keys [close]} submitting?]
      [notes-s
       [notes-header-s
        [notes-title-s "NOTES"]
        [notes-close-s {:on-click close} [icon/close {:width "20px" :height "20px"}]]]
       [:form
        {:on-submit (fn [e]
                      (.preventDefault e)
                      (>evt [:guidebook/create-note @form-values]))}
        [notes-text-area-s {:name "value"
                            :placeholder "Write your note here..."
                            :max-length 250
                            :min-length 1
                            :on-change #(swap! form-values assoc :value (.. % -target -value))}]
        [notes-submit-s {:type "submit"
                         :disabled submitting?
                         :value "ADD NOTE"}]]])))
